import { render } from "./PaymentDetails.vue?vue&type=template&id=d5c1baa4&scoped=true&lang=pug"
import script from "./PaymentDetails.vue?vue&type=script&lang=ts"
export * from "./PaymentDetails.vue?vue&type=script&lang=ts"

import "./PaymentDetails.vue?vue&type=style&index=0&id=d5c1baa4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d5c1baa4"

export default script